import { createAction } from 'redux-actions';

export const setCurrentDigest = createAction('SET_CURRENT_DIGEST', digest => ({ digest }));

export const getTopPosts = createAction('GET_TOP_POSTS', (siteId, day, type) => ({ siteId, day, type }));
export const getTopPostsSuccess = createAction('GET_TOP_POSTS_SUCCESS', posts => ({ posts }));
export const getTopPostsFailure = createAction('GET_TOP_POSTS_FAILURE');

export const clearRecentPosts = createAction('CLEAR_RECENT_POSTS');

export const clearCurrentDigest = createAction('CLEAR_CURRENT_DIGEST');
export const clearCurrentDigestSuccess = createAction('CLEAR_CURRENT_DIGEST_SUCCESS');
export const clearCurrentDigestFailure = createAction('CLEAR_CURRENT_DIGEST_FAILURE');

export const recentPosts = createAction('RECENT_POSTS', siteId => ({ siteId }));
export const recentPostsSuccess = createAction('RECENT_POSTS_SUCCESS', posts => ({ posts }));
export const recentPostsFailure = createAction('RECENT_POSTS_FAILURE');

export const searchDigests = createAction('SEARCH_DIGESTS', query => ({ query }));
export const searchDigestsSuccess = createAction('SEARCH_DIGESTS_SUCCESS', digests => ({ digests }));
export const searchDigestsFailure = createAction('SEARCH_DIGESTS_FAILURE');

export const searchHOTW = createAction('SEARCH_HOTW', query => ({ query }));
export const searchHOTWSuccess = createAction('SEARCH_HOTW_SUCCESS', publications => ({ publications }));
export const searchHOTWFailure = createAction('SEARCH_HOTW_FAILURE');

export const searchPromoAlerts = createAction('SEARCH_PROMO_ALERTS', query => ({ query }));
export const searchPromoAlertsSuccess = createAction('SEARCH_PROMO_ALERTS_SUCCESS', publications => ({ publications }));
export const searchPromoAlertsFailure = createAction('SEARCH_PROMO_ALERTS_FAILURE');

export const getDigests = createAction('GET_DIGESTS');
export const getDigestsSuccess = createAction('GET_DIGESTS_SUCCESS', digests => ({ digests }));
export const getDigestsFailure = createAction('GET_DIGESTS_FAILURE');

export const getDigestById = createAction('GET_DIGEST_BY_ID', id => ({ id }));
export const getDigestByIdSuccess = createAction('GET_DIGEST_BY_ID_SUCCESS', digest => ({ digest }));
export const getDigestByIdFailure = createAction('GET_DIGEST_BY_ID_FAILURE');

export const deleteDigestById = createAction('DELETE_DIGEST', id => ({ id }));
export const deleteDigestByIdSuccess = createAction('DELETE_DIGEST_SUCCESS', digests => ({ digests }));
export const deleteDigestByIdFailure = createAction('DELETE_DIGEST_FAILURE');

export const addDailyDigest = createAction('ADD_DAILY_DIGEST', publication => ({ publication }));
export const addDailyDigestSuccess = createAction('ADD_DAILY_DIGEST_SUCCESS');
export const addDailyDigestFailure = createAction('ADD_DAILY_DIGEST_FAILURE');

export const getDigestTestEmail = createAction('GET_DIGEST_TEST_EMAIL', id => ({ id }));
export const getDigestTestEmailSuccess = createAction('GET_DIGEST_TEST_EMAIL_SUCCESS');
export const getDigestTestEmailFailure = createAction('GET_DIGEST_TEST_EMAIL_FAILURE');

export const cloneDailyDigest = createAction('CLONE_DAILY_DIGEST', digest => ({ digest }));
export const cloneDailyDigestSuccess = createAction('CLONE_DAILY_DIGEST_SUCCESS');
export const cloneDailyDigestFailure = createAction('CLONE_DAILY_DIGEST_FAILURE');

export const updateDailyDigest = createAction('UPDATE_DAILY_DIGEST', digest => ({ digest }));
export const updateDailyDigestSuccess = createAction('UPDATE_DAILY_DIGEST_SUCCESS');
export const updateDailyDigestFailure = createAction('UPDATE_DAILY_DIGEST_FAILURE');

export const scheduleDailyDigest = createAction('SCHEDULE_DAILY_DIGEST', id => ({ id }));
export const scheduleDailyDigestSuccess = createAction('SCHEDULE_DAILY_DIGEST_SUCCESS');
export const scheduleDailyDigestFailure = createAction('SCHEDULE_DAILY_DIGEST_FAILURE');

export const getPromoAlerts = createAction('GET_PROMO_ALERTS');
export const getPromoAlertsSuccess = createAction('GET_PROMO_ALERTS_SUCCESS', publications => ({ publications }));
export const getPromoAlertsFailure = createAction('GET_PROMO_ALERTS_FAILURE');

export const getPromoAlertById = createAction('GET_PROMO_ALERT_BY_ID', id => ({ id }));
export const getPromoAlertByIdSuccess = createAction('GET_PROMO_ALERT_BY_ID_SUCCESS', publication => ({ publication }));
export const getPromoAlertByIdFailure = createAction('GET_PROMO_ALERT_BY_ID_FAILURE');

export const deletePromoAlertById = createAction('DELETE_PROMO_ALERT_BY_ID', (id, returnTo = '/promo-alert') => ({
  id,
  returnTo,
}));
export const deletePromoAlertByIdSuccess = createAction('DELETE_PROMO_ALERT_BY_ID_SUCCESS', publications => ({
  publications,
}));
export const deletePromoAlertByIdFailure = createAction('DELETE_PROMO_ALERT_BY_ID_FAILURE');

export const addPromoAlert = createAction('ADD_PROMO_ALERT', publication => ({ publication }));
export const addPromoAlertSuccess = createAction('ADD_PROMO_ALERT_SUCCESS');
export const addPromoAlertFailure = createAction('ADD_PROMO_ALERT_FAILURE');

export const updatePromoAlert = createAction('UPDATE_PROMO_ALERT', publication => ({ publication }));
export const updatePromoAlertSuccess = createAction('UPDATE_PROMO_ALERT_SUCCESS', publication => ({ publication }));
export const updatePromoAlertFailure = createAction('UPDATE_PROMO_ALERT_FAILURE');

export const clonePromoAlert = createAction('CLONE_PROMO_ALERT', publication => ({ publication }));
export const clonePromoAlertSuccess = createAction('CLONE_PROMO_ALERT_SUCCESS', publication => ({ publication }));
export const clonePromoAlertFailure = createAction('CLONE_PROMO_ALERT_FAILURE');

export const schedulePromoAlert = createAction('SCHEDULE_PROMO_ALERT', id => ({ id }));
export const schedulePromoAlertSuccess = createAction('SCHEDULE_PROMO_ALERT_SUCCESS');
export const schedulePromoAlertFailure = createAction('SCHEDULE_PROMO_ALERT_FAILURE');

export const getPromoAlertTestEmail = createAction('GET_PROMO_ALERT_TEST_EMAIL', id => ({ id }));
export const getPromoAlertTestEmailSuccess = createAction('GET_PROMO_ALERT_TEST_EMAIL_SUCCESS');
export const getPromoAlertTestEmailFailure = createAction('GET_PROMO_ALERT_TEST_EMAIL_FAILURE');

// HOTW

export const getHotw = createAction('GET_HOTW');
export const getHotwSuccess = createAction('GET_HOTW_SUCCESS', publications => ({ publications }));
export const getHotwFailure = createAction('GET_HOTW_FAILURE');

export const setHotwQuery = createAction('SET_HOTW_QUERY', hotwQuery => ({ hotwQuery }));
export const setPromoAlertQuery = createAction('SET_PROMO_ALERT_QUERY', promoAlertQuery => ({ promoAlertQuery }));
export const setCityRinkQuery = createAction('SET_CITY_RINK_QUERY', cityRinkQuery => ({ cityRinkQuery }));

export const getHotwById = createAction('GET_HOTW_BY_ID', id => ({ id }));
export const getHotwByIdSuccess = createAction('GET_HOTW_BY_ID_SUCCESS', publication => ({ publication }));
export const getHotwByIdFailure = createAction('GET_HOTW_BY_ID_FAILURE');

export const deleteHotwById = createAction('DELETE_HOTW_BY_ID', id => ({ id }));
export const deleteHotwByIdSuccess = createAction('DELETE_HOTW_BY_ID_SUCCESS', publication => ({ publication }));
export const deleteHotwByIdFailure = createAction('DELETE_HOTW_BY_ID_FAILURE');

export const getHotwListingById = createAction('GET_HOTW_LISTING_BY_ID', id => ({ id }));
export const getHotwListingByIdSuccess = createAction('GET_HOTW_LISTING_BY_ID_SUCCESS', listing => ({ listing }));
export const getHotwListingByIdFailure = createAction('GET_HOTW_LISTING_BY_ID_FAILURE');

export const addHotw = createAction('ADD_HOTW', publication => ({ publication }));
export const addHotwSuccess = createAction('ADD_HOTW_SUCCESS');
export const addHotwFailure = createAction('ADD_HOTW_FAILURE');

export const cloneHotw = createAction('CLONE_HOTW', publication => ({ publication }));
export const cloneHotwSuccess = createAction('CLONE_HOTW_SUCCESS');
export const cloneHotwFailure = createAction('CLONE_HOTW_FAILURE');

export const updateHotw = createAction('UPDATE_HOTW', publication => ({ publication }));
export const updateHotwSuccess = createAction('UPDATE_HOTW_SUCCESS', publication => ({ publication }));
export const updateHotwFailure = createAction('UPDATE_HOTW_FAILURE');

export const scheduleHotw = createAction('SCHEDULE_HOTW', id => ({ id }));
export const scheduleHotwSuccess = createAction('SCHEDULE_HOTW_SUCCESS');
export const scheduleHotwFailure = createAction('SCHEDULE_HOTW_FAILURE');

export const getHotwTestEmail = createAction('GET_HOTW_TEST_EMAIL', id => ({ id }));
export const getHotwTestEmailSuccess = createAction('GET_HOTW_TEST_EMAIL_SUCCESS');
export const getHotwTestEmailFailure = createAction('GET_HOTW_TEST_EMAIL_FAILURE');

// NEWS ALERT

export const getNewsAlerts = createAction('GET_NEWS_ALERTS');
export const getNewsAlertsSuccess = createAction('GET_NEWS_ALERTS_SUCCESS', publications => ({ publications }));
export const getNewsAlertsFailure = createAction('GET_NEWS_ALERTS_FAILURE');

export const getNewsAlertById = createAction('GET_NEWS_ALERT_BY_ID', id => ({ id }));
export const getNewsAlertByIdSuccess = createAction('GET_NEWS_ALERT_BY_ID_SUCCESS', publication => ({ publication }));
export const getNewsAlertByIdFailure = createAction('GET_NEWS_ALERT_BY_ID_FAILURE');

export const deleteNewsAlertById = createAction('DELETE_NEWS_ALERT_BY_ID', id => ({ id }));
export const deleteNewsAlertByIdSuccess = createAction('DELETE_NEWS_ALERT_BY_ID_SUCCESS', publication => ({
  publication,
}));
export const deleteNewsAlertByIdFailure = createAction('DELETE_NEWS_ALERT_BY_ID_FAILURE');

export const addNewsAlert = createAction('ADD_NEWS_ALERT', publication => ({ publication }));
export const addNewsAlertSuccess = createAction('ADD_NEWS_ALERT_SUCCESS');
export const addNewsAlertFailure = createAction('ADD_NEWS_ALERT_FAILURE');

export const cloneNewsAlert = createAction('CLONE_NEWS_ALERT', publication => ({ publication }));
export const cloneNewsAlertSuccess = createAction('CLONE_NEWS_ALERT_SUCCESS');
export const cloneNewsAlertFailure = createAction('CLONE_NEWS_ALERT_FAILURE');

export const updateNewsAlert = createAction('UPDATE_NEWS_ALERT', publication => ({ publication }));
export const updateNewsAlertSuccess = createAction('UPDATE_NEWS_ALERT_SUCCESS');
export const updateNewsAlertFailure = createAction('UPDATE_NEWS_ALERT_FAILURE');

export const scheduleNewsAlert = createAction('SCHEDULE_NEWS_ALERT', id => ({ id }));
export const scheduleNewsAlertSuccess = createAction('SCHEDULE_NEWS_ALERT_SUCCESS');
export const scheduleNewsAlertFailure = createAction('SCHEDULE_NEWS_ALERT_FAILURE');

export const getNewsAlertTestEmail = createAction('GET_NEWS_ALERT_TEST_EMAIL', id => ({ id }));
export const getNewsAlertTestEmailSuccess = createAction('GET_NEWS_ALERT_TEST_EMAIL_SUCCESS');
export const getNewsAlertTestEmailFailure = createAction('GET_NEWS_ALERT_TEST_EMAIL_FAILURE');
